import React from "react";
import Spline from "@splinetool/react-spline";
import { Link } from "react-router-dom";
import "./Home.css";

function Home() {
  return (
    <div style={{backgroundColor:"D2D2D2"}}>
        <div className="relative">
        <div className="bg-[#e6f1ff] min-h-screen flex justify-center items-center">
      <div className="max-w-4xl mx-auto p-6 flex justify-between items-center">
        <div className="flex flex-col">
          <h1 className="text-5xl font-bold text-[#034078]">Welcome to 5YNOW</h1>
          <p className="text-xl text-[#034078] mt-4">Your passport to a sustainable world</p>
        </div>
        <div className="relative">
      <Spline style={{width:'50vw', height:'50vw'}} scene="https://prod.spline.design/vqi9nerAMhQ27PXX/scene.splinecode" />

        </div>
      </div>
    </div>
    </div>
    </div>
  );
}

export default Home;
